import { type FormEvent, useState } from 'react'
import { Link } from 'react-router'

import { useAuth } from '@langmail/shared-ui'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Logo } from '@/components/ui/logo'

export const ForgotPassword = () => {
  const { requestPasswordReset } = useAuth()

  const [email, setEmail] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [sent, setSent] = useState(false)

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault()
    setSubmitting(true)
    // Ignore the result: we always show the same neutral confirmation so the
    // page never reveals whether an account (or recovery email) exists.
    await requestPasswordReset(email.trim())
    setSent(true)
    setSubmitting(false)
  }

  return (
    <div className="flex h-dvh w-dvw flex-col items-center justify-center bg-background">
      <div className="w-full max-w-[400px] px-10 text-center">
        <Logo />

        <div className="mt-16 text-left">
          <h1 className="mb-3 text-center font-semibold text-2xl text-foreground">Reset your password</h1>

          {sent ? (
            <p className="text-center text-muted-foreground text-sm">
              If an account exists for that address, we’ve sent a reset link to its recovery email.
            </p>
          ) : (
            <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
              <p className="text-center text-muted-foreground text-sm">
                Enter your Langmail address. We’ll email a reset link to the recovery address on file.
              </p>
              <div className="space-y-1.5">
                <Label htmlFor="email">Langmail address</Label>
                <Input
                  autoCapitalize="none"
                  autoComplete="username"
                  autoCorrect="off"
                  id="email"
                  onChange={(event) => setEmail(event.target.value)}
                  placeholder="alice@langmail.me"
                  spellCheck={false}
                  type="email"
                  value={email}
                />
              </div>
              <Button
                className="w-full rounded-lg bg-primary px-8 py-4 text-[15px] text-primary-foreground hover:bg-primary/90"
                disabled={submitting || email.trim().length === 0}
                type="submit"
              >
                {submitting ? 'Sending…' : 'Send reset link'}
              </Button>
            </form>
          )}

          <p className="mt-6 text-center text-muted-foreground text-sm">
            <Link className="underline hover:text-foreground" to="/login">
              Back to sign in
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
